import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { User } from '../users/user';
import { AuthenticationService } from '../shared/authentication.service';

@Component({
  selector: 'dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  loading = false;
  user: User;
  errors = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.user = this.authenticationService.user();
  }

  isLoggedIn(): boolean {
    return this.authenticationService.isLoggedIn();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts